<template>
  <div :class="[b(), { 'om-hairline-top-bottom': border }]">
    <template v-if="title">
      <div :class="b('title')">{{title}}</div>
      <slot />
    </template>
    <template v-else>
      <slot />
    </template>
  </div>
</template>


<script>
import create from '../utils/create-basic';

export default create({
  name: 'cell-group',

  props: {
    title: {
      type: String,
      default: '',
    },
    border: {
      type: Boolean,
      default: true
    }
  }
});
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/cell-group/index.vue